module.exports = __webpack_public_path__ + "media/images/niq-arrow-down-0d169c324fceca889465b6a8df2ac5da.svg";